/** Session flag: user must stay on account-deleted until they log out. */
export const ACCOUNT_DELETED_SESSION_KEY = "tv_account_deleted";

export function isAccountNotFoundApiError(err: unknown): boolean {
  const e = err as { response?: { status?: number; data?: { message?: string } } };
  if (e?.response?.status !== 404) return false;
  const msg = String(e?.response?.data?.message ?? "")
    .trim()
    .toLowerCase();
  return msg === "account not found" || msg.includes("account not found");
}

export function markAccountDeletedSession(): void {
  try {
    sessionStorage.setItem(ACCOUNT_DELETED_SESSION_KEY, "1");
  } catch {
    // ignore
  }
}

export function clearAccountDeletedSession(): void {
  try {
    sessionStorage.removeItem(ACCOUNT_DELETED_SESSION_KEY);
  } catch {
    // ignore
  }
}

export function isAccountDeletedSession(): boolean {
  try {
    return sessionStorage.getItem(ACCOUNT_DELETED_SESSION_KEY) === "1";
  } catch {
    return false;
  }
}

/** API paths still allowed while the user is on the account-deleted screen. */
export function isAllowedDuringAccountDeletedSession(url: string): boolean {
  const path = String(url || "");
  return (
    path.includes("users/me") || path.includes("users/recreateAccount")
  );
}
